const dateUtil = {
  // YY년 MM월 DD일 HH:MM ~ HH:MM
  examDateFormat: (startDateString, endDateString) => {
    try {
      const startDate = new Date(startDateString);
      const endDate = new Date(endDateString);

      const year = startDate.getFullYear().toString(); // '2024'로 만듦
      const month = String(startDate.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 1 더함
      const day = String(startDate.getDate()).padStart(2, '0');
      const startHours = String(startDate.getHours()).padStart(2, '0');
      const startMinutes = String(startDate.getMinutes()).padStart(2, '0');

      const endHours = String(endDate.getHours()).padStart(2, '0');
      const endMinutes = String(endDate.getMinutes()).padStart(2, '0');

      return `${year}-${month}-${day} ${startHours}:${startMinutes} ~ ${endHours}:${endMinutes}`;

    } catch(error){
      console.log("시험 날짜 출력 Error")
      return ""
    }
  },
}
export default dateUtil;